export const GameModes = {
  ENGLISH_TO_CHINESE: {
    id: 1,
    name: "英譯中",
    description: "Translate English to Chinese.",
    timeLimit: null, // Default for non-time challenge
    wordCount: 10, // Default for non-time challenge
  },
  CHINESE_TO_ENGLISH: {
    id: 2,
    name: "中譯英",
    description: "Translate Chinese to English.",
    timeLimit: null,
    wordCount: 10,
  },
  PICTURE_TO_WORD: {
    id: 3,
    name: "看圖識字",
    description: "Identify the English word from a picture.",
    timeLimit: null,
    wordCount: 10,
  },
  LISTEN_ENGLISH_WORD: {
    id: 4,
    name: "聽音辨字 (英)",
    description:
      "Listen to an English word and choose the correct English spelling.",
    timeLimit: null,
    wordCount: 10,
  },
  LISTEN_CHINESE_WORD: {
    id: 5,
    name: "聽音辨字 (中)",
    description:
      "Listen to an English word and choose the correct Chinese translation.",
    timeLimit: null,
    wordCount: 10,
  },
  TIME_CHALLENGE: {
    id: 6, // Assign a new ID for time challenge
    name: "限時挑戰",
    description: "Answer as many questions as possible within a time limit.",
    timeLimit: 60, // seconds
    wordCount: null, // Not applicable, based on time
  },
};
